const ALL_NODE_KEY = '0-0';
const DEFAULT_REQUIRED = 'defaultRequired';
const REQUIRED = 'required';
const OPTIONAL = 'optional';

export { ALL_NODE_KEY, DEFAULT_REQUIRED, REQUIRED, OPTIONAL };
